import React from "react";
import { useCurrentAccountQuery } from "../../../../api/queries/useAccountQuery";

export const withShopifyEnabled = (Component) => (props) => {
  const { data: account } = useCurrentAccountQuery();

  return (
    <Component
      {...props}
      isShopifyEnabled={!!account?.integrations?.isShopifyEnabled}
    />
  );
};
